import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { v4 as uuidv4, v4 } from 'uuid';
import { getRoomOption } from "../../../base/conference";
import JitsiMeetJS, { JitsiConferenceEvents, JitsiConnectionEvents } from "../../../base/lib-jitsi-meet";
import { MEDIA_TYPE } from "../../../base/media";
import { getLocalTracks, getTrackState } from "../../../base/tracks";
import { getGroupParticipant, getStartGroup, getStartGroupList } from "../../../group";

class Jitsi {
    constructor(room, access_token, handler) {
        this.room = room;
        this.access_token = access_token;
        this.handler = handler;
        this.connection = null;
        this.conference = null;
    }

    connect() {
        const connectionConfig = Object.assign({}, {
            serviceUrl: `wss://${location.host}/xmpp-websocket?room=${this.room?.code}`,
            hosts: {
                domain: "mate.net",
                muc: "muc.mate.net",
            },
            ㄷbleSimulcast: false,
            p2p: true
        });

        JitsiMeetJS.init();
        const connection = new JitsiMeetJS.JitsiConnection(null, null, connectionConfig);
    
        this.connection = connection;

        connection.addEventListener(
            JitsiConnectionEvents.CONNECTION_ESTABLISHED, () => {
                console.log("connection");

                this.enterRoom();
            });
        connection.addEventListener(
            JitsiConnectionEvents.CONNECTION_FAILED, () => {
                console.log("connection failed");
                this.connection = null;
            });
        connection.addEventListener(
            JitsiConnectionEvents.CONNECTION_DISCONNECTED, () => {
                console.log("connection disconnect");
                this.connection = null;
            });

        connection.connect();
    }

    disconnect() {
        if (this.connection) this.connection.disconnect();
    }

    enterRoom() {
        console.log("enter")
        const roomName = ""+this.room.code;
        const confOptions = {
            openBridgeChannel: true,
        };

        const conference = this.connection.initJitsiConference(roomName, confOptions);  

        this.conference = conference;
        this.conferenceWillJoin();
        this._setupListeners();            
        conference.join();        
    }

    _setupListeners() {
        const handler = this.handler;
        this.conference.on(JitsiConferenceEvents.CONFERENCE_JOINED, () => {
            console.log("conference joined", this.conference.myUserId());

            handler.setPerson(this.conference.myUserId(), this.conference);
        });
    }

    async conferenceWillJoin() {
        const tracks = getTrackState(APP.store.getState());
        const localTrack = getLocalTracks(tracks);
        // const localTracktest = await APP.mateManagement.initLocalTrack({
        //     devices: [ 'audio', 'video' ] 
        // });

        localTrack.map(t => {
            if (t.mediaType === MEDIA_TYPE.VIDEO) this.conference.addTrack(t.track);
            if (t.mediaType === MEDIA_TYPE.AUDIO) this.conference.addTrack(t.track);
        })

        // this.conference.addTrack(newAudioTrack);
        // this.conference.addTrack(newVideoTrack);
    }
}

class Mate {
    constructor(room, access_token, localID, handler, mateTemp) {
        this.room = room;
        this.access_token = access_token;
        this.localID = localID;
        this.mateTemp = mateTemp;

        this.connecting = false;
        this.websocket = null;

        const groupParticipant = getGroupParticipant(APP.store.getState());

        const group = groupParticipant.find(p => p.user_id === this.localID);
        this.initGroup = group?.group_id;

        const uuid = uuidv4();
        const nickname = "test"+uuid;
        this.nickname = nickname;
    } 

    connect() {
        const websocket = new WebSocket(`wss://${location.host}/svc/room/ws?room=${this.access_token}`);
        this.websocket = websocket;

        websocket.addEventListener("open", () => {
            console.log("websocket connection");

            this.connecting = true;
            this.setAuthorization();
        });
        websocket.addEventListener("close", () => {
            console.log("websocket close");
        });
        websocket.addEventListener("error", () => {
            console.log("websocket error");
        });
        websocket.addEventListener("message", hanleSendMessage.bind(this));

        function hanleSendMessage(ev) {
            if (this.websocket != websocket) {
                return;
            }
            let { data } = ev;
            try {
                data = JSON.parse(data);
            } catch (err) {
                console.log(err);
                data = JSON.parse(data);

                return;
            }
            this.reciveMessage(data);
        };

        this.mateTemp.connect(this.access_token, this.initGroup, this.nickname);
        
    }

    disconnect() {
        if (websocket) websocket.close();
    }

    sendMessage(name, payload) {
        try {
            if (!name && !this.connecting) return;

            const uuid = uuidv4();
            const cmdReqData = Object.assign(
                {
                    class: name, 
                    id: uuid,
                }, 
            );

            const meeting_id = APP.mateManagement.getMeetingId();
            cmdReqData.payload = {
                ...payload,
                meeting_id,
                group_id: ""
            };;
            this.websocket && this.websocket.send(JSON.stringify(cmdReqData));
        } catch (e) {
            console.log(e)
        }        
    }

    setAuthorization() {
        const token = this.access_token;
        this.sendMessage("User.Auth.Set", {
            access_token: token
        });
    } 

    enterRoom() {

        const nickname = this.nickname;
        const roomName = this.room.uuid;
        
        // EnterMeeting
        this.sendMessage("Room.Member.Join", {
            meeting_uuid: roomName,
            password: null,
            nickname,
            video_track_id: null, // videoTrack?.track?.track?.id,
            audio_track_id: null, // audioTrack?.track?.track?.id,
            role_name_forced: null
        });
    }

    setJitsi(bridge_session_id) {
        this.sendMessage("Room.Member.BridgeSession.Set", {
            bridge_session_id
        });
    }
    unsetGroup({ group_id, meeting_id, role_name, user_id }) {
        const groupStart = getStartGroup(APP.store.getState());
        if (groupStart) { 
            if (user_id === this.localID) {
                const groupParticipant = getGroupParticipant(APP.store.getState());

                const group = groupParticipant.find(p => p.user_id === this.localID);
                const group_id = group ? group.group_id : "";
                const startList = getStartGroupList(APP.store.getState());
                if (id === "" || startList.indexOf(group_id) !== -1) {
                    // change meeting
                    this.mateTemp.setGroupId(group_id, this.nickname);
                }
            }
        }
    }

    assignGroup({ group_id, meeting_id, role_name, user_id }) {
        const groupStart = getStartGroup(APP.store.getState());
        if (groupStart) { 
            if (user_id === this.localID) {
                const groupParticipant = getGroupParticipant(APP.store.getState());

                const group = groupParticipant.find(p => p.user_id === this.localID);
                const group_id = group ? group.group_id : "";
                const startList = getStartGroupList(APP.store.getState());
                if (startList.indexOf(group_id) !== -1) {
                    this.mateTemp.setGroupId(group_id, this.nickname);
                } else {
                    this.mateTemp.setGroupId("", this.nickname);
                }
            }
        }  
    }

    startGroup({ group_id }) {
        const groupParticipant = getGroupParticipant(APP.store.getState());

        const group = groupParticipant.find(p => p.user_id === this.localID);
        if (group && group_id === group.group_id) {
            // start 
            this.mateTemp.setGroupId(group_id, this.nickname);
        }
    }

    endGroup({ group_id }) {
        const groupParticipant = getGroupParticipant(APP.store.getState());

        const group = groupParticipant.find(p => p.user_id === this.localID);
        if (group && group_id === group.group_id) {
            // end close 
            this.mateTemp.setGroupId("", this.nickname);
        }
    }

    async reciveMessage(data) {
        switch (data.class) {
            case "User.Auth.Set":
                this.enterRoom();
                console.log('test')
                break;

            case "Room.Member.Join": 
                // local ID                
                break;

            // 그룹 멤버 할당 -> 그룹으로 이동 (시작 되어있는 경우)
            case 'Meeting.Member.GroupAssigned':
                setTimeout(() => {
                    this.assignGroup(data.payload);
                }, 1000);
                break;

            // 그룹 멤버 할당 해제 -> 그룹에서 left 
            case "Meeting.Member.GroupLeft":
                setTimeout(() => {
                    this.unsetGroup(data.payload);
                }, 1000);
                break;

            // 그룹 시작과 종료
            case "Meeting.Meeting.GroupStatusChanged":
                setTimeout(() => {
                    if (data.payload.status === "opened") this.startGroup(data.payload);
                    else this.endGroup(data.payload);
                }, 1000);
                break;
        }
    }
}

class TempMate {
    constructor(localID) {
        this.localID = localID;

        this.connecting = false;
        this.websocket = null;

        this.nickname;
        this.initGroup;
    } 

    connect(access_token, initGroup, nickname) {
        this.access_token = access_token;
        this.nickname = nickname;
        this.initGroup = initGroup;
        const websocket = new WebSocket(`wss://${location.host}/svc/room/ws?group_temp_${this.access_token}`);
        this.websocket = websocket;

        websocket.addEventListener("open", () => {
            console.log("websocket connection");

            this.connecting = true;
            this.setAuthorization();
        });
        websocket.addEventListener("close", () => {
            console.log("websocket close");
        });
        websocket.addEventListener("error", () => {
            console.log("websocket error");
        });
        websocket.addEventListener("message", hanleSendMessage.bind(this));

        function hanleSendMessage(ev) {
            if (this.websocket != websocket) {
                return;
            }
            let { data } = ev;
            try {
                data = JSON.parse(data);
            } catch (err) {
                console.log(err);
                data = JSON.parse(data);

                return;
            }
            this.reciveMessage(data);
        };

    }

    disconnect() {
        if (websocket) websocket.close();
    }

    setGroupId(group_id, nickname) {
        
        this.nickname = nickname;
        // leave 
        this.leave();

        if (group_id !== "") {
            console.log({group_id})
            this.group_id = group_id;
            // join
            this.enterRoom();
        }        
    }

    sendMessage(name, payload) {
        try {
            const uuid = uuidv4();
            const cmdReqData = Object.assign(
                {
                    class: name, 
                    id: uuid,
                }, 
            );

            const meeting_id = APP.mateManagement.getMeetingId();
            cmdReqData.payload = {
                ...payload,
                meeting_id,
                group_id: this.group_id
            };;
            this.websocket && this.websocket.send(JSON.stringify(cmdReqData));
        } catch (e) {
            console.log(e)
        }        
    }

    setAuthorization() {
        const token = this.access_token;
        this.sendMessage("User.Auth.Set", {
            access_token: token
        });
    } 

    leave() {
        this.sendMessage("Room.Member.Leave", null);
    }

    enterRoom() {
        const nickname = this.nickname;

        // EnterMeeting
        this.sendMessage("Room.Member.Join", {
            password: null,
            nickname,
            role_name_forced: null
        });
    }

    async reciveMessage(data) {
        switch (data.class) {
            case "User.Auth.Set":
                this.setGroupId(this.initGroup, this.nickname);
                break;
        }
    }
}

// const token_list = [
//     "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJleHAiOjE2NTk3NDM5ODUsImlhdCI6MTY1ODg3OTk4NSwidXNlciI6eyJ1dWlkIjoiNmZhYzFiMTQtYmNmYi00YmFjLWIwODEtODQ5NDgzNGUzMTkxIiwidXNlcl9pZCI6IjZmYWMxYjE0LWJjZmItNGJhYy1iMDgxLTg0OTQ4MzRlMzE5MSIsInRlbmFudF9pZCI6IiIsImF1dGhfbmFtZSI6IjZmYWMxYjE0LWJjZmItNGJhYy1iMDgxLTg0OTQ4MzRlMzE5MSIsInJvbGUiOnsibmFtZSI6ImFub255bW91cyIsImxldmVsIjowLCJwZXJtaXNzaW9ucyI6W119fX0.f_QJVtrN8oCvXVSZA2kN8rcdNeGZCciShaYXvr5aaTI",
//     "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJleHAiOjE2NTk3NDQwMDQsImlhdCI6MTY1ODg4MDAwNCwidXNlciI6eyJ1dWlkIjoiZDAwOTg1ZTItZDdiNy00MDhkLTgzY2UtOGNjNDAyZTM3OGMzIiwidXNlcl9pZCI6ImQwMDk4NWUyLWQ3YjctNDA4ZC04M2NlLThjYzQwMmUzNzhjMyIsInRlbmFudF9pZCI6IiIsImF1dGhfbmFtZSI6ImQwMDk4NWUyLWQ3YjctNDA4ZC04M2NlLThjYzQwMmUzNzhjMyIsInJvbGUiOnsibmFtZSI6ImFub255bW91cyIsImxldmVsIjowLCJwZXJtaXNzaW9ucyI6W119fX0.oq35baiErHYWe2VYfLvF0K7TVmlSbeKQATPB5CtoT4k",
//     "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJleHAiOjE2NTk3NDQwMDUsImlhdCI6MTY1ODg4MDAwNSwidXNlciI6eyJ1dWlkIjoiZmM0ZDAyZGMtMDlmOS00YjhiLWEyNWYtMGUwNjIxYmRkYjM1IiwidXNlcl9pZCI6ImZjNGQwMmRjLTA5ZjktNGI4Yi1hMjVmLTBlMDYyMWJkZGIzNSIsInRlbmFudF9pZCI6IiIsImF1dGhfbmFtZSI6ImZjNGQwMmRjLTA5ZjktNGI4Yi1hMjVmLTBlMDYyMWJkZGIzNSIsInJvbGUiOnsibmFtZSI6ImFub255bW91cyIsImxldmVsIjowLCJwZXJtaXNzaW9ucyI6W119fX0.E_p2IDRKgeSbZUDhyfg78ZgzmUu8Ls-avwwKZzK_MDs",
//     "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJleHAiOjE2NTk3NDQwMjEsImlhdCI6MTY1ODg4MDAyMSwidXNlciI6eyJ1dWlkIjoiOTU1ODI5N2YtODdlZS00ZmNjLTgyNjAtNDU2ODFmZTBiNTc5IiwidXNlcl9pZCI6Ijk1NTgyOTdmLTg3ZWUtNGZjYy04MjYwLTQ1NjgxZmUwYjU3OSIsInRlbmFudF9pZCI6IiIsImF1dGhfbmFtZSI6Ijk1NTgyOTdmLTg3ZWUtNGZjYy04MjYwLTQ1NjgxZmUwYjU3OSIsInJvbGUiOnsibmFtZSI6ImFub255bW91cyIsImxldmVsIjowLCJwZXJtaXNzaW9ucyI6W119fX0.nyQnvENItCZANwPArK8haXwFwzv6xwsm5enWJmTWDok",
//     "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJleHAiOjE2NTk3NDQwMzEsImlhdCI6MTY1ODg4MDAzMSwidXNlciI6eyJ1dWlkIjoiNTBhM2YwNjAtMDNhMy00ZTJmLTljNGItOTY4M2I1MzhjMDUyIiwidXNlcl9pZCI6IjUwYTNmMDYwLTAzYTMtNGUyZi05YzRiLTk2ODNiNTM4YzA1MiIsInRlbmFudF9pZCI6IiIsImF1dGhfbmFtZSI6IjUwYTNmMDYwLTAzYTMtNGUyZi05YzRiLTk2ODNiNTM4YzA1MiIsInJvbGUiOnsibmFtZSI6ImFub255bW91cyIsImxldmVsIjowLCJwZXJtaXNzaW9ucyI6W119fX0.rRVrLR6K5D0L_V6jHIbN6OQd_feGdJyhvdpvORr-AB4",
//     "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJleHAiOjE2NTk3NDQwNDksImlhdCI6MTY1ODg4MDA0OSwidXNlciI6eyJ1dWlkIjoiMzMzNTIwYjMtMzkxNi00NzI0LWIwMGYtZWFkMjBjMThkMzhhIiwidXNlcl9pZCI6IjMzMzUyMGIzLTM5MTYtNDcyNC1iMDBmLWVhZDIwYzE4ZDM4YSIsInRlbmFudF9pZCI6IiIsImF1dGhfbmFtZSI6IjMzMzUyMGIzLTM5MTYtNDcyNC1iMDBmLWVhZDIwYzE4ZDM4YSIsInJvbGUiOnsibmFtZSI6ImFub255bW91cyIsImxldmVsIjowLCJwZXJtaXNzaW9ucyI6W119fX0.jU2n_ODiTsM-TL4KyFDzjpw-3Mh-3zByVwQwWSGmqNc",
//     "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJleHAiOjE2NTk3NDQwNjMsImlhdCI6MTY1ODg4MDA2MywidXNlciI6eyJ1dWlkIjoiY2ViOWFiZTgtYmY2OS00Y2I0LTlkY2MtZmRkYjg3ZTdhZTIxIiwidXNlcl9pZCI6ImNlYjlhYmU4LWJmNjktNGNiNC05ZGNjLWZkZGI4N2U3YWUyMSIsInRlbmFudF9pZCI6IiIsImF1dGhfbmFtZSI6ImNlYjlhYmU4LWJmNjktNGNiNC05ZGNjLWZkZGI4N2U3YWUyMSIsInJvbGUiOnsibmFtZSI6ImFub255bW91cyIsImxldmVsIjowLCJwZXJtaXNzaW9ucyI6W119fX0.6gEiWla4TGt-21tp-A0qUQ41gXVESyMVt9GVm7yfwEI",
//     "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJleHAiOjE2NTk3NDQwNzYsImlhdCI6MTY1ODg4MDA3NiwidXNlciI6eyJ1dWlkIjoiOWVlNzM4NWYtMWZhYS00ZmQyLWI3YmYtZTEwMjBlNTIyZjU0IiwidXNlcl9pZCI6IjllZTczODVmLTFmYWEtNGZkMi1iN2JmLWUxMDIwZTUyMmY1NCIsInRlbmFudF9pZCI6IiIsImF1dGhfbmFtZSI6IjllZTczODVmLTFmYWEtNGZkMi1iN2JmLWUxMDIwZTUyMmY1NCIsInJvbGUiOnsibmFtZSI6ImFub255bW91cyIsImxldmVsIjowLCJwZXJtaXNzaW9ucyI6W119fX0.PnMQDj-cwwTUI08xBAVqkepfzYxUC_qtRKTlzJlJ_Y8",
//     "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJleHAiOjE2NTk3NDQwOTcsImlhdCI6MTY1ODg4MDA5NywidXNlciI6eyJ1dWlkIjoiYTE2ZTBkZjItZjY1YS00MDk2LWEzMjMtNDRjNTQxZjZiYWY0IiwidXNlcl9pZCI6ImExNmUwZGYyLWY2NWEtNDA5Ni1hMzIzLTQ0YzU0MWY2YmFmNCIsInRlbmFudF9pZCI6IiIsImF1dGhfbmFtZSI6ImExNmUwZGYyLWY2NWEtNDA5Ni1hMzIzLTQ0YzU0MWY2YmFmNCIsInJvbGUiOnsibmFtZSI6ImFub255bW91cyIsImxldmVsIjowLCJwZXJtaXNzaW9ucyI6W119fX0.YrUBTcHyle0n71Q0CGnUTkM-7TRkGxDtkmT5fERAqxs",
//     "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJleHAiOjE2NTk3NDQwODgsImlhdCI6MTY1ODg4MDA4OCwidXNlciI6eyJ1dWlkIjoiOWU3MWQ2YTctMGNjMy00MzVlLWIzYWEtNDY4Mjc0ZjJmYmQ5IiwidXNlcl9pZCI6IjllNzFkNmE3LTBjYzMtNDM1ZS1iM2FhLTQ2ODI3NGYyZmJkOSIsInRlbmFudF9pZCI6IiIsImF1dGhfbmFtZSI6IjllNzFkNmE3LTBjYzMtNDM1ZS1iM2FhLTQ2ODI3NGYyZmJkOSIsInJvbGUiOnsibmFtZSI6ImFub255bW91cyIsImxldmVsIjowLCJwZXJtaXNzaW9ucyI6W119fX0.Lz7mXss4AFyt1rSU2r7eUlOB16aXaLnXEuKmtKqmGU4",
//     "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJleHAiOjE2NTk3NDQxMTcsImlhdCI6MTY1ODg4MDExNywidXNlciI6eyJ1dWlkIjoiMGZkM2U4OTUtNGNhNy00YjY3LTk1NzItYzNmZWYxYzc0ODVlIiwidXNlcl9pZCI6IjBmZDNlODk1LTRjYTctNGI2Ny05NTcyLWMzZmVmMWM3NDg1ZSIsInRlbmFudF9pZCI6IiIsImF1dGhfbmFtZSI6IjBmZDNlODk1LTRjYTctNGI2Ny05NTcyLWMzZmVmMWM3NDg1ZSIsInJvbGUiOnsibmFtZSI6ImFub255bW91cyIsImxldmVsIjowLCJwZXJtaXNzaW9ucyI6W119fX0.R-5-A0IYQNmuwE1c3epPLpBKTpiVYFsfVvDH9vHA2JY",
// ];

let mateTest;
function TestAddPerson({
    roomOption
}) {
    const [tempPerson, setTempPerson] = useState(new Map());

    const onClick = () => {        
        // token_list.map(async (access_token, index) => {   
        //     const mateTemp = new TempMate();
        //     // 토큰으로 local id 가져오기 
        //     const { message, complete } = await APP.API.getUser(access_token);

        //     const localID = message.user.user_id;
        //     const uuid = v4();

        //     const handler = {
        //         setPerson : (id, connect) => {
        //             const {mate} = tempPerson.get(uuid);
        //             mate.setJitsi(id);
        //         }
        //     };

            
        //     const mateTest = new Mate(roomOption, access_token, localID, handler, mateTemp);
        //     const jitsiTest = new Jitsi(roomOption, access_token, handler);

        //     tempPerson.set(uuid, {mate: mateTest, jitsi: jitsiTest});                

        //     jitsiTest.connect(),
        //     mateTest.connect()   
        // });
        
        APP.API.tempLogin()
            .then(async ({ message: data }) => {

                const mateTemp = new TempMate();
                // 토큰으로 local id 가져오기 
                const access_token = data?.access_token;
                const { message, complete } = await APP.API.getUser(access_token);
    
                const localID = message.user.user_id;
                const uuid = v4();
    
                const handler = {
                    setPerson : (id, connect) => {
                        const {mate} = tempPerson.get(uuid);
                        mate.setJitsi(id);
                    }
                };    
                
                const mateTest = new Mate(roomOption, access_token, localID, handler, mateTemp);
                const jitsiTest = new Jitsi(roomOption, access_token, handler);
                tempPerson.set(uuid, {mate: mateTest, jitsi: jitsiTest});                

                jitsiTest.connect(),
                mateTest.connect()                
            });    
    }

    const handlerSetJitsi = (id) => {
        mateTest.setJitsi(id);
    }

    return (
        <>
            <button className="btn btn_middle" onClick={onClick}>추가</button>
        </>
    );
}

function _mapStateToProps(state) {
    const roomOption = getRoomOption(state); // {name, uuid, code}
    return {
        roomOption
    }
}

export default connect(_mapStateToProps)(TestAddPerson);